export const VERIFICATION_STATUS_VERIFIED = 'verified';
export const VERIFICATION_STATUS_SUBMITTED = 'verification_submitted';
export const VERIFICATION_STATUS_DECLINED = 'verification_declined';

export const VERIFF_API_KEY =
  process.env.REACT_APP_VERIFF_KEY || '4b454135-6390-45f2-b4ea-7746d1f218f3';
